











import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class Setting extends Vue {
  @Prop()
  label!: string

  @Prop({
    default: 180
  })
  labelWidth?: number
}
